import React from "react";

const HiddenField = ({ name, idField, value, ...props }) => {
  return (
    <input
      id={idField || name}
      name={name}
      defaultValue={value}
      type="hidden"
      {...props}
    />
  );
};

export default HiddenField;
